import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'dialogs-errors-system',
    templateUrl: './dialogs-errors-system.component.html',
    styleUrls: ['./dialogs-errors-system.component.scss']
})
export class DialogsErrorsSystemComponent implements OnInit {
    session: boolean;
    version: boolean;

    constructor(
        public dialogRef: MatDialogRef<DialogsErrorsSystemComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit() {
        if (this.data) {
            switch(this.data) {
                case "Session expirée":
                    this.session = true;
                    break;
                case "Version différente":
                    this.version = true;
                    break;
                default:
                    this.data = "";
            }
        }
    }
    dismissDialog(){
        this.dialogRef.close();
    }
    dismissDialogReloadOnLogin(){ // #1592
        this.dialogRef.close();
        location.href = '/client/dist/homepage';
    }
    
    dismissAndReload() {
        this.dialogRef.close();
        window.location.reload();
    }
}